import React from 'react'

// third party components

// images and icons
import EditMetaIcon from 'assets/icons/edit-meta-22x22.svg?component'
import ShareSmallIcon from 'assets/icons/share-black-menu.svg?component'
import DownloadIcon from 'assets/icons/download-icon.svg?component'

// styles
import styles from './index.module.scss'

interface MenuEditPageProps {
  setShowEditMerch: any
  isCreatedMerch: any
  setOpenShareModal: any
  showDownloadMockups: boolean
  downloadFiles: any
}

const MenuEditMerchPage = ({
  setShowEditMerch,
  isCreatedMerch,
  setOpenShareModal,
  showDownloadMockups,
  downloadFiles,
}: MenuEditPageProps) => {
  return (
    <div className={styles.menuArea}>
      {isCreatedMerch && (
        <div
          className={`${styles.menuItem}`}
          onClick={() => {
            setShowEditMerch(true)
          }}
        >
          <div className="flex gap-[15px] items-center">
            <div className={styles.itemIcon}>
              <EditMetaIcon alt="" />
            </div>
            <div>
              <div className={styles.itemTitle}>Edit Item</div>
              <div className={styles.itemDescription}>Update item name or description.</div>
            </div>
          </div>
          <div className={styles.separator} />
        </div>
      )}

      <div
        className={`${showDownloadMockups ? styles.menuItem : styles.menuLastItem}`}
        onClick={() => {
          setOpenShareModal(true)
        }}
      >
        <div className="flex gap-[15px] items-center">
          <div className={styles.itemIcon}>
            <ShareSmallIcon alt="" />
          </div>
          <div>
            <div className={styles.itemTitle}>Share Item</div>
            <div className={styles.itemDescription}>Share to socials or copy link</div>
          </div>
        </div>
        {showDownloadMockups && <div className={styles.separator} />}
      </div>

      {showDownloadMockups && (
        <div
          className={`${styles.menuLastItem}`}
          onClick={() => {
            downloadFiles()
          }}
        >
          <div className="flex gap-[15px] items-center">
            <div className={styles.itemIcon}>
              <DownloadIcon alt="" />
            </div>
            <div>
              <div className={styles.itemTitle}>Download Mockups</div>
              <div className={styles.itemDescription}>Save item images to your device</div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default MenuEditMerchPage
